import React from 'react';
import style from './Activity.module.css';
import documentFile from '../../../../../../src/assets/img/document-file.svg';
import { calculateTimeAgo } from 'utils/Helpers';

export default function UserActivity({ name, activity, time, activityDetails }) {
  const cleanActivityHtml = (html) => {
    if (!html) return html;

    return html.replace(/<br\s*\/?>/gi, '').replace(/<\/?p[^>]*>/gi, '');
  };

  const cleanedActivity = cleanActivityHtml(activity);

  return (
    <div className={style.user_activity_content}>
      <div className={style.commented_name_wrapper}>
        <div className={style.name}>
          {name} <span className="caption" dangerouslySetInnerHTML={{ __html: cleanedActivity }} />
          {activityDetails?.attachments?.length > 0 &&
            activityDetails.attachments.map((x) => {
              return (
                <div className="uploadfile-details">
                  <div className="leftContent">
                    <img src={documentFile} alt="avatar" />
                  </div>
                  <div className="righteftContent">
                    <p>{x.name}</p>
                    <span>{calculateTimeAgo(x.uploadedAt)}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="time-stamp">{time}</div>
    </div>
  );
}
